import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'ReferMe - SPPU Engineering Notes, Study Materials & PYQs',
  description = 'Get SPPU engineering notes, study materials, and previous year question papers (PYQs). Access curated handwritten notes with branch-wise exam prep resources.',
  keywords = 'engineering notes, study materials, PYQ, previous year papers, exam preparation, university notes, CSE notes, IT notes, SPPU notes, sppu notes, engineering study guide',
  image = 'https://referme.pixenstudio.in/logo192.png',
  url = 'https://referme.pixenstudio.in',
  type = 'website',
  author = 'ReferMe',
  canonicalUrl,
  noindex = false,
  children
}) => {
  const siteUrl = 'https://referme.pixenstudio.in';
  const fullUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const canonical = canonicalUrl || fullUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="ReferMe" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional children (for page-specific meta tags or scripts) */}
      {children}
    </Helmet>
  );
};

export default SEO;
